exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "hr {\r\n  border-top: 5px solid #eee;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Biziclick/bizisystem/src/app/main/frames/cross-parameters/cross-parameters.component.css
// module id = ../../../../../src/app/main/frames/cross-parameters/cross-parameters.component.css
// module chunks = main